import { Component, Input, OnInit } from '@angular/core'
import { InformacoesInstitucionaisModel } from '@shared/models/backend'
import { Observable } from 'rxjs'
import { InfosInstitucionaisService } from './infos-institucionais.service'

@Component({
  selector: 'app-infos-institucionais',
  templateUrl: './infos-institucionais.component.html',
})
export class InfosInstitucionaisComponent implements OnInit {
  @Input()
  infosInstitucionais$: Observable<InformacoesInstitucionaisModel>
  @Input()
  showTitle = true

  constructor(private infosInstitucionaisService: InfosInstitucionaisService) {}

  ngOnInit(): void {
    if (!this.infosInstitucionais$) {
      this.initInfos()
    }
  }

  private initInfos() {
    this.infosInstitucionais$ = this.infosInstitucionaisService.getInfosInstitucionais()
  }
}
